type AnalyticsProvider = (name: string, properties?: Record<string, unknown>) => void;

const providers: AnalyticsProvider[] = [];

export function registerAnalyticsProvider(provider: AnalyticsProvider) {
  providers.push(provider);
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (import.meta.env.DEV) {
    console.log("[analytics]", name, properties);
  }
  for (const provider of providers) {
    try {
      provider(name, properties);
    } catch {
      // Never let analytics break the app
    }
  }
}
